import { spacing } from '@kite-js/system';
import { css } from 'styled-components';

// https://github.agodadev.io/agoda-front-end/kite-js/blob/v0.17.6/packages/core/src/CssBaseline/resets.tsx
const resets = css`
    html,
    body {
        ${spacing({ p: 'NONE', m: 'NONE' })}
    }
`;

export default resets;
